import { apiClient } from '../utils/apiClient.js';
import appInsightsLogger from '../utils/appInsights.js';

class AdminService {
  async getSystemHealth() {
    try {
      return await apiClient.get('/api/admin/system-health');
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService'
      });

      console.error('Error getting system health:', error);
      throw error;
    }
  }

  async getAdminActivities(days = 7) {
    try {
      return await apiClient.get(`/api/admin/activities?days=${days}`);
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        days: days
      });

      console.error('Error getting admin activities:', error);
      throw error;
    }
  }

  async getPaginatedAdminActivities(pageNumber = 1, pageSize = 10, days = 7) {
    try {
      return await apiClient.get(`/api/admin/activities?pageNumber=${pageNumber}&pageSize=${pageSize}&days=${days}`);
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        pageNumber: pageNumber,
        pageSize: pageSize,
        days: days
      });

      console.error('Error getting paginated admin activities:', error);
      throw error;
    }
  }

  async lockUser(request) {
    try {
      await apiClient.post('/api/admin/lock-user', request);
      return true;
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        targetUserId: request.userId
      });

      console.error('Error locking user:', error);
      throw error;
    }
  }

  async unlockUser(request) {
    try {
      await apiClient.post('/api/admin/unlock-user', request);
      return true;
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        targetUserId: request.userId
      });

      console.error('Error unlocking user:', error);
      throw error;
    }
  }

  async bulkPasswordReset(request) {
    try {
      return await apiClient.post('/api/admin/bulk-password-reset', request);
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        userCount: request.users?.length
      });

      console.error('Error in bulk password reset:', error);
      throw error;
    }
  }

  async bulkUnlock(request) {
    try {
      return await apiClient.post('/api/admin/bulk-unlock', request);
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        userCount: request.users?.length
      });

      console.error('Error in bulk unlock:', error);
      throw error;
    }
  }

  // Register a new user via admin UI
  async registerUser(request) {
    try {
      // Endpoint assumed to be implemented server-side: POST /api/admin/register-user
      return await apiClient.post('/api/admin/register-user', request);
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        action: 'registerUser'
      });
      console.error('Error registering user:', error);
      throw error;
    }
  }

  async getAllOrganizations() {
    try {
      const response = await apiClient.get('/api/data/organizations');
      return response;
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        action: 'getAllOrganizations'
      });
      console.error('Error fetching organizations:', error);
      throw error;
    }
  }

  async getAllUserRoles() {
    try {
      const response = await apiClient.get('/api/data/user-roles');
      return response;
    } catch (error) {
      appInsightsLogger.trackException(error, {
        component: 'adminService',
        action: 'getAllUserRoles'
      });
      console.error('Error fetching user roles:', error);
      throw error;
    }
  }
}

export const adminService = new AdminService();
